import React from "react";

const Header = () => {
   return (
       <header className="header">
           <p>PhysProperties</p>
       </header>
   )
}

export default Header;
